define('bizzabo/views/QuestionView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/consts',
    'bizzabo/views/right/EditQuestionView',
    'hbars!bizzabo/templates/pollQuestion'

], function(
    $,
    Backbone,
    _,
    Consts,
    EditQuestionView,
    pollQuestionTemplate
    ) {

    var QuestionView = Backbone.View.extend({
        events: {
            'click .pollQuestion' : 'pollQuestionClicked'
        },
        initialize : function() {
            this.listenTo(this.model, 'change', this.render);
            this.listenTo(this.model, 'validated', this.checkIfValid);
            if (this.model.get('choices')) {
                this.listenTo(this.model.get('choices'), 'validated', this.checkIfValid);
            }

            this.listenTo(Backbone, Consts.Notifications.mainPage.POLLS_PAGE_LOADED, this.onPageLoad);
        },

        pollQuestionClicked : function() {
            this.options.pollsView.putRightPanelView(new EditQuestionView({
                model : this.model,
                poll : this.options.pollModel,
                pollsView : this.options.pollsView
            }));

            this.options.pollsView.showDetails();
            this.options.pollsView.openDetails(true);
            this.options.pollsView.$el.removeClass('width550 width0').addClass('width440');

            this.options.pollsView.setQuestionsSelected(this);
        },

        checkIfValid : function() {
            var shouldValidate = this.model.wasEdited || this.model.isSynced;
            this.$('.poll-question-name').toggleClass('poll-invalid', shouldValidate && !this.model.isAllModelValid());
        },

        render : function() {
            var isSelected = this.$('.poll-question-name').hasClass('answerSelected');
            var jsonData = _.extend(this.model.toJSON(), {cid: this.model.cid, isSelected: isSelected});
            var html = pollQuestionTemplate(jsonData);
            this.$el.html(html);
            return this;
        },

        onPageLoad : function() {
            this.model.validate();
        }
    });

    return QuestionView;

});
